<div [formGroup]="form" class="wrapper" [ngClass]="getFormClasses()">
  <quill-editor
    #quill
    class="input"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (keydown.tab)="noTab ? disableTab($event) : null"
    (keydown.enter)="onEnterPressed($event)"
    [tabindex]="disabled ? -1 : tabIndex"
    [required]="required"
    [placeholder]="formStates.labelRaised ? placeholder : ''"
    [modules]="quillModules"
    [(ngModel)]="value"
    (onContentChanged)="onQuillContentChange($event)"
    (editorCreated)="onQuillEditorReady($event)"
    [ngModelOptions]="{ standalone: true }"
    [styles]="{ border: 'none', outline: 'none' }"
    [ngClass]="{
      'medium-height': size === 'medium',
      'large-height': size === 'large',
    }"
    *ngIf="useQuillEditor"
  ></quill-editor>
  <textarea
    #input
    class="input textarea"
    [attr.aria-label]="ariaLabel ?? label"
    [cols]="columns"
    [rows]="rows"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (keydown.tab)="noTab ? disableTab($event) : null"
    (keydown.enter)="onEnterPressed($event)"
    [tabindex]="disabled ? -1 : tabIndex"
    [required]="required"
    [maxlength]="maxlength"
    [placeholder]="formStates.labelRaised ? placeholder : ''"
    formControlName="formValue"
    *ngIf="!useQuillEditor"
  ></textarea>
  <div class="notch">
    <div class="lead"></div>
    <div class="mt-[-9px]" *ngIf="labelShow">
      <label class="lines-{{ labelLines }}">{{ label }}</label>
    </div>
    <div class="trail"></div>
  </div>
</div>
<div class="info" *ngIf="info">
  <span>{{ info }}</span>
</div>
<div class="hint">
  <span
    [ngClass]="{ error: minimumChars && charsTyped < minimumChars }"
    *ngIf="minimumChars > -1 && charsTyped === 0"
  >
    {{
      'ON_BOARDING.PROFILE.BIO.MINIMUM_CHARS'
        | translate: { value: minimumChars | thousand }
    }}
  </span>
  <span
    [ngClass]="{ error: maximumChars && charsTyped > maximumChars }"
    *ngIf="maximumChars > -1 && charsTyped > 0"
    >{{ charsTyped | thousand }} / {{ maximumChars | thousand }}</span
  >
</div>
<div class="error" *ngIf="formStates.error" [@dropdownAnimation]>
  <span>{{ errorMessage }}</span>
</div>
